<style lang="sass">
@import '../../variables'

</style>

<template lang="pug">
el-form(@keyup.enter.native='submit')
  el-alert(v-if='loginError != null', :title='loginError', type='error')
  el-form-item(label='Email')
    el-input(v-model='email', :autofocus='true')
  el-form-item(label='Password')
    el-input(v-model='password', type='password', auto-complete='off', @keyup.enter='submit')
  el-form-item
    el-button(type='primary', @click='submit', :loading='submitting', class='full-width-button') Sign In
</template>

<script>
  import auth from "../../auth.js"
  export default {
    data() {
      return {
        email: '',
        password: '',
        loginError: null,
        submitting: false
      };
    },
    methods: {
      submit() {
        this.loginError = null
        this.submitting = true
        const handleNewSession = (session) => {
          this.submitting = false
          if(session.group === 'staff'){
            this.$router.push('/staff/overview')
          }else{
            this.$router.push('/user/overview')
          }
        }
        const handleFailedLogin = (description, error) => {
          console.log("Login failed", description, error)
          this.submitting = false
          this.loginError = description
        }
        auth.login(this.email.trim(), this.password.trim())
          .then(handleNewSession)
          .catch(handleFailedLogin)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/anonymous/blocks/LoginForm.vue